import { LayerPatternItem } from 'interfaces/calculator';
import PatternId from 'enums/patterns';

import {ReactComponent as Icon3a} from '@icons/patterns/3a.svg';
import {ReactComponent as Icon4a} from '@icons/patterns/4a.svg';
import {ReactComponent as Icon4b} from '@icons/patterns/4b.svg';
import {ReactComponent as Icon5a} from '@icons/patterns/5a.svg';
import {ReactComponent as Icon6a} from '@icons/patterns/6a.svg';
import {ReactComponent as Icon6b} from '@icons/patterns/6b.svg';
import {ReactComponent as Icon6d} from '@icons/patterns/6d.svg';
import {ReactComponent as Icon7a} from '@icons/patterns/7a.svg';
import {ReactComponent as Icon8a} from '@icons/patterns/8a.svg';
import {ReactComponent as Icon8c} from '@icons/patterns/8c.svg';
import {ReactComponent as Icon8d} from '@icons/patterns/8d.svg';
import {ReactComponent as Icon9a} from '@icons/patterns/9a.svg';
import {ReactComponent as Icon9b} from '@icons/patterns/9b.svg';
import {ReactComponent as Icon9d} from '@icons/patterns/9d.svg';
import {ReactComponent as Icon10a} from '@icons/patterns/10a.svg';
import {ReactComponent as Icon10c} from '@icons/patterns/10c.svg';
import {ReactComponent as Icon10j} from '@icons/patterns/10j.svg';
import {ReactComponent as Icon11a} from '@icons/patterns/11a.svg';
import {ReactComponent as Icon12a} from '@icons/patterns/12a.svg';
import {ReactComponent as Icon12b} from '@icons/patterns/12b.svg';
import {ReactComponent as Icon13a} from '@icons/patterns/13a.svg';
import {ReactComponent as Icon13b} from '@icons/patterns/13b.svg';
import {ReactComponent as Icon14a} from '@icons/patterns/14a.svg';
import {ReactComponent as Icon15a} from '@icons/patterns/15a.svg';
import {ReactComponent as Icon16d} from '@icons/patterns/16d.svg';
import {ReactComponent as Icon18a} from '@icons/patterns/18a.svg';
import {ReactComponent as Icon20c} from '@icons/patterns/20c.svg';
import {ReactComponent as IconGrid} from '@icons/patterns/grid.svg';

// const patternsIcons: LayerPatternItem[] = [
//   { label: PatternId.A3, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A4, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.B4, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A5, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A6, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.B6, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.D6, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A7, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A8, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.C8, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.D8, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A9, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.B9, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.D9, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A10, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.C10, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.J10, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A11, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A12, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.B12, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A13, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.B13, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A14, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A15, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.D16, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.A18, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.C20, icon: PatternMetadata[PatternId.A3].svg },
//   { label: PatternId.GRID, icon: PatternMetadata[PatternId.A3].svg },
// ];


const patternsIcons: LayerPatternItem[] = [
  { label: PatternId.A3, icon: Icon3a },
  { label: PatternId.A4, icon: Icon4a },
  { label: PatternId.B4, icon: Icon4b },
  { label: PatternId.A5, icon: Icon5a },
  { label: PatternId.A6, icon: Icon6a },
  { label: PatternId.B6, icon: Icon6b },
  { label: PatternId.D6, icon: Icon6d },
  { label: PatternId.A7, icon: Icon7a },
  { label: PatternId.A8, icon: Icon8a },
  { label: PatternId.C8, icon: Icon8c },
  { label: PatternId.D8, icon: Icon8d },
  { label: PatternId.A9, icon: Icon9a },
  { label: PatternId.B9, icon: Icon9b },
  { label: PatternId.D9, icon: Icon9d },
  { label: PatternId.A10, icon: Icon10a },
  { label: PatternId.C10, icon: Icon10c },
  { label: PatternId.J10, icon: Icon10j },
  { label: PatternId.A11, icon: Icon11a },
  { label: PatternId.A12, icon: Icon12a },
  { label: PatternId.B12, icon: Icon12b },
  { label: PatternId.A13, icon: Icon13a },
  { label: PatternId.B13, icon: Icon13b },
  { label: PatternId.A14, icon: Icon14a },
  { label: PatternId.A15, icon: Icon15a },
  { label: PatternId.D16, icon: Icon16d },
  { label: PatternId.A18, icon: Icon18a },
  { label: PatternId.C20, icon: Icon20c },
  { label: PatternId.GRID, icon: IconGrid },
];


export default patternsIcons;
